/* istanbul ignore file */
import { Box, Typography } from '@mui/material';

const SeriesItem = ({ seriesItem, highlighted = false }) => (
  <Box
    display="grid"
    gridTemplateColumns="auto 1fr auto"
    alignItems="center"
    columnGap={1.5}
  >
    <Box aria-label={`${seriesItem.formattedLabel}-series-color`}>
      <div
        style={{
          width: 16,
          height: 4,
          borderRadius: 2,
          backgroundColor: seriesItem.color,
        }}
      />
    </Box>
    <Typography fontWeight={highlighted ? 'bold' : 'light'} whiteSpace="nowrap">
      {seriesItem.formattedLabel}
    </Typography>
    <Typography>{seriesItem.formattedValue}</Typography>
  </Box>
);

export default SeriesItem;
